import { createAsyncThunk } from "@reduxjs/toolkit";
import { EntityDocumentType } from "@dataRooms/models";
import { openNotificationThunk } from "@store/Notification/thunks";
import { ThunkApiConfig } from "@shared/models/redux";

const inFlightEntityDocumentTypeIds = new Set<number>();

export const fetchEntityDocumentTypes = createAsyncThunk<EntityDocumentType[], number, ThunkApiConfig>(
  "dataRooms/fetchEntityDocumentTypes",
  async (entityId, { rejectWithValue, extra, dispatch }) => {
    inFlightEntityDocumentTypeIds.add(entityId);
    try {
      const response = await extra<EntityDocumentType[]>(
        `documents/v1/Documents/entitledEntity/${entityId}/documentTypes`
      );

      return response.data;
    } catch (e) {
      dispatch(
        openNotificationThunk({
          variant: "warning",
          text: "Failed to load data",
        })
      );

      return rejectWithValue("Failed to load entity document types");
    } finally {
      inFlightEntityDocumentTypeIds.delete(entityId);
    }
  },
  {
    condition: (entityId) => !inFlightEntityDocumentTypeIds.has(entityId),
  }
);
